import React, { useState, useEffect } from 'react';
import Icon from '../ui/Icon';
import { ICONS } from '../ui/icon-map';

const NetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!isOnline) {
        return (
            <div
                role="alert"
                dir="rtl"
                className="flex items-start gap-3 px-4 py-3 mb-4 rounded-lg border text-sm"
                style={{ background: 'var(--danger-soft)', borderColor: 'var(--danger-200)', color: 'var(--text)' }}
            >
                <Icon glyph={ICONS.error} size="sm" tone="danger" className="mt-0.5" />
                <div className="flex-1">
                    <strong className="font-semibold">No internet connection</strong>
                    <p className="text-gray-600">Check your connection and try again.</p>
                </div>
            </div>
        );
    }

    return null;
};

export default NetworkStatus;
